<template>
  <span class="time">{{ formatted }}</span>
</template>
<script>
export default {
  props: {
    scheduled: {type: String, required: true}
  },
  data() {
    return { now: Date.now(), timer: null }
  },
  computed: {
    diff() {
      return new Date(this.scheduled) - this.now;
    },
    formatted() {
      if (this.diff <= 0) return '00:00';
      const d = Math.floor(this.diff / (1000 * 60 * 60 * 24));
      const h = Math.floor((this.diff / (1000 * 60 * 60)) % 24);
      const m = Math.floor((this.diff / (1000 * 60)) % 60);
      const s = Math.floor((this.diff / 1000) % 60);
      return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
    }
  },
  mounted() {
    this.timer = setInterval(() => this.now = Date.now(), 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
}
</script>
<style scoped>
.time { font-size: var(--font-size-2xl); color: var(--about-to-start); font-weight: bold; }

</style>